import React from "react";
import {Banner} from "@shopify/polaris";

const Notice = ({show,status,message,onClose})=>{
    if(show) {
        return (<><Banner status={status} onDismiss={onClose}><p>{message}</p></Banner><br/></>)
    }else {
        return (<></>);
    }
}

export default Notice;
